module["exports"] = [
  "com",
  "es",
  "info",
  "com.es",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/internet/domain_suffix.js
// module id = 738
// module chunks = 0